import{createContext as r}from"react";const e=r({name:"",value:""}),{Provider:o}=e;export{e as Context,o as Provider};
//# sourceMappingURL=context.js.map
